import React, { useState } from 'react';
import { Alert, Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrollableDialog from '../common/ScrollableDialog';
import PrimaryActionButton from '../common/PrimaryActionButton';
import { EXPENSE_EDIT_SCOPES } from '../../constants/Expenses';

const RecurrenceScopeDialog = ({ open, mode = 'edit', onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [scope, setScope] = useState('OnlyThis');

  return (
    <ScrollableDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={mode === 'delete' ? t('expenses.scope.deleteTitle') : t('expenses.scope.editTitle')}
      dividers
      showCloseButton
      titleSx={{ pb: 1, flexShrink: 0 }}
      actionsSx={{ flexShrink: 0, justifyContent: 'space-between' }}
      actions={(
        <>
          <Button onClick={onClose} color="inherit">{t('common.cancel')}</Button>
          <PrimaryActionButton id="recurrence-scope-confirm" onClick={() => onConfirm(scope)}>
            {t('common.confirm')}
          </PrimaryActionButton>
        </>
      )}
    >
      <Box id="recurrence-scope-dialog">
        <RadioGroup value={scope} onChange={(event) => setScope(event.target.value)}>
          {EXPENSE_EDIT_SCOPES.map((item) => (
            <FormControlLabel
              key={item}
              value={item}
              control={<Radio id={`expense-scope-${item}`} />}
              label={t(`expenses.scope.${item}`)}
            />
          ))}
        </RadioGroup>
        {scope === 'All' ? (
          <Alert severity="warning" sx={{ mt: 2 }}>
            <Typography variant="body2">{t('expenses.scope.allWarning')}</Typography>
          </Alert>
        ) : null}
      </Box>
    </ScrollableDialog>
  );
};

export default RecurrenceScopeDialog;
